<template>
  <div class="header white--text">
    <v-row class="py-2 px-3 px-md-16">
      <v-col cols="12">
        <v-toolbar-title
          class="font-weight-bold text-lg-h5 text-md-h5 text-sm-body-1 mb-1">
          <template v-if="backTo">
            <v-btn small rounded icon :to="backTo">
              <v-icon light color="accent">mdi-chevron-left</v-icon>
            </v-btn>
          </template>
          {{ nomePagina }}
        </v-toolbar-title>
      </v-col>

      <v-col cols="12" md="5" class="py-0">
        <v-text-field
          v-if="buscaPlaceHolder"
          append-icon="mdi-magnify"
          solo
          light
          color="accent"
          :label="buscaPlaceHolder"
          v-model="computedSearch"></v-text-field>
      </v-col>

      <v-col cols="12" md="7" class="pt-0">
        <slot></slot>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  props: {
    nomePagina: {
      type: String,
    },
    buscaPlaceHolder: {
      type: String,
    },
    backTo: {
      type: String,
    },
    search: {
      type: String,
    },
  },
  emits: ["search"],
  computed: {
    computedSearch: {
      get() {
        return this.search
      },
      set(value) {
        this.$emit("search", value)
      },
    },
  },
  components: {},
}
</script>
